import * as React from 'react';
import { Properties } from '../';
import { ISubmission, DOMHelper } from '../../helpers';
import {
    DialogFooter,
	Button, ButtonType,
	IDropdownOption
} from 'office-ui-fabric-react';

interface IProps {
	submission: ISubmission;
	outputOptions:IDropdownOption[];
	closeDialog: (save?: boolean) => void;
	updateProperty: (key: string, value: any) => void;
}

export class SubmissionConfig extends React.Component<IProps, any> {

	constructor(props: any) {
        super(props);
    }

	public componentDidMount() {
        DOMHelper.setDropdownPropertyTabIndex();
        DOMHelper.focusOnFirstModalTabbableControl();
	}

	public render() {

		let { submission, outputOptions, closeDialog, updateProperty } = this.props;

		return (
			<div>
                
				<Properties primaryOnly={ false } change={ updateProperty } componentId={ submission.ComponentId } properties={ submission.Properties } 
					outputOptions={outputOptions} />

                <DialogFooter>
                    <Button tabIndex={1001} buttonType={ ButtonType.normal } onClick={ () => closeDialog(false) }>Cancel</Button>
                    <Button tabIndex={1002} onBlur={ () => { DOMHelper.focusOnFirstModalTabbableControl(); } }
						buttonType={ ButtonType.primary } onClick={ () => closeDialog(true) }>Save</Button>
                </DialogFooter>

			</div>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/submission/submission-config.tsx